import { render } from "./PregnancyInfoAboutBaby.vue?vue&type=template&id=458361ce"
import script from "./PregnancyInfoAboutBaby.vue?vue&type=script&lang=js"
export * from "./PregnancyInfoAboutBaby.vue?vue&type=script&lang=js"

import "./PregnancyInfoAboutBaby.vue?vue&type=style&index=0&id=458361ce&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__